var exports = {
  "A2": "typeSwitcherButton__BaAfsG",
  "QQ": "counterWrapper__2JY2-Z",
  "qX": "resolvedCountLabel__Oj6hbP",
  "jG": "dropdownWrapper__wAcP9r",
  "Jp": "filterLabel__3xyPSa",
};

module.exports = exports;
